import type { TOC } from '@ember/component/template-only'
import { LinkTo } from '@ember/routing'
import { eq } from 'ember-truth-helpers'
import { t } from 'ember-intl'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Args {
  themeKey?: ThemeKeys
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
}

export const PageHeaderManageTabs: TOC<Signature> = <template>
  <div data-test-manage-tabs class="flex justify-center text-2xl" ...attributes>
    <LinkTo
      data-test-students-link
      @route="manage.students"
      class="border-dusty-black-200 bg-dusty-black-100 text-dusty-black-300 hover:text-dusty-black-300 focus:text-dusty-black-300 active-link:border-r-2 active-link:text-white rounded-l-md border-y-2 border-l-2 px-14 py-3
        {{if (eq @themeKey ThemeKeys.blue) 'active-link:border-oceany-blue-400 active-link:bg-oceany-blue-300'}}
        {{if (eq @themeKey ThemeKeys.green) 'active-link:border-ms-green-400 active-link:bg-ms-green-300'}}
        {{if (eq @themeKey ThemeKeys.darkBlue) 'active-link:border-wl-blue-300 active-link:bg-wl-blue-250'}}"
    >
      {{t "manage.manageClasses.students.title"}}
    </LinkTo>
    <LinkTo
      data-test-classes-link
      @route="manage.classes"
      class="border-dusty-black-200 bg-dusty-black-100 text-dusty-black-300 hover:text-dusty-black-300 focus:text-dusty-black-300 active-link:border-l-2 active-link:text-white rounded-r-md border-y-2 border-r-2 px-14 py-3
        {{if (eq @themeKey ThemeKeys.blue) 'active-link:border-oceany-blue-400 active-link:bg-oceany-blue-300'}}
        {{if (eq @themeKey ThemeKeys.green) 'active-link:border-ms-green-400 active-link:bg-ms-green-300'}}
        {{if (eq @themeKey ThemeKeys.darkBlue) 'active-link:border-wl-blue-300 active-link:bg-wl-blue-250'}}"
    >
      {{t "manage.manageClasses.classes.title"}}
    </LinkTo>
  </div>
</template>

export default PageHeaderManageTabs
